<template>
  <div id="instances-slim-list">
    <div v-if="!minimum">
      <vs-table
        pagination
        :search="search"
        :data="instances"
        :max-items="itemsPerPage"
        noDataText="Sem dados disponíveis"
      >
        <template slot="thead">
          <vs-th style="width: 50px" v-if="checkbox"></vs-th>
          <vs-th sort-key="name">Nome</vs-th>
        </template>

        <template slot-scope="{data}">
          <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td>
              <vs-checkbox v-model="selecteds" :vs-value="tr.id"/>
            </vs-td>

            <vs-td>
              <p v-if="showNickname">{{ tr.nickname || tr.name }}</p>
              <p v-else>{{ tr.name }}</p>
            </vs-td>
          </vs-tr>
          </tbody>
        </template>
      </vs-table>
    </div>
    <div v-else>
      <div :key="indextr" v-for="(tr, indextr) in instances" class="flex mb-2">
        <vs-td>
          <vs-checkbox v-model="selecteds" :vs-value="tr.id" :title="showNickname ? tr.nickname || tr.name : tr.name">
            <div class="flex">
              <p class="align-self-center">
                {{ (showNickname ? tr.nickname || tr.name : tr.name) | truncate(tr.activated?20:15, true) }}
              </p>
              <feather-icon v-if="!tr.activated" icon="AlertTriangleIcon" svgClasses="ml-2 pt-1 w-7 h-7 text-warning"/>
            </div>
          </vs-checkbox>
        </vs-td>
      </div>
    </div>
  </div>
</template>

<script>
  import moduleInstance from '@/store/instance/moduleInstance'

  export default {
    props: {
      checkbox: {
        type: Boolean,
        required: false
      },
      search: {
        type: Boolean,
        required: false
      },
      selecteds: {
        required: false,
        default(){ return [] },
        validator: prop => typeof prop === 'object' || prop === null
      },
      showNickname: {
        type: Boolean,
        required: false,
        default(){ return false },
      },
      minimum: {
        type: Boolean,
        required: false,
        default(){ return false },
      },
    },
    data() {
      return {
        itemsPerPage: 4
      }
    },
    computed: {
      instances() {
        if ( !moduleInstance.isRegistered ) {
          this.$store.registerModule('instance', moduleInstance)
          moduleInstance.isRegistered = true
        }
        return this.$store.state.instance.instances !== undefined ? this.$store.state.instance.instances : []
      },
    },
    created() {
      if ( !this.$store.state.instance.instances.length ){
        this.$store.dispatch("instance/fetch", {
          activated: true,
          user_id: this.$store.state.AppActiveUser.id
        })
      }
    },
    watch: {
      selecteds: function() {
        this.$emit("selectedInstances", this.selecteds);
      }
    }
  }
</script>
